import { Button, CircularProgress } from "@mui/material";

const Processing = ({ text, fullWidth }) => {
  return (
    <Button className="button-height-sm alignByLang" variant="text" fullWidth={fullWidth}>
      <span>{text}</span> <CircularProgress className="mx-2" size={25} />
    </Button>
  );
};

export default Processing;
